import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetBeneficiaryAddressSuggestionV4,
	GetBeneficiaryAddressSuggestionV4Params,
	GetBeneficiaryAddressSuggestionV4Response,
} from 'domain/usecases';

export class RemoteGetBeneficiaryAddressSuggestionV4 implements GetBeneficiaryAddressSuggestionV4 {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetBeneficiaryAddressSuggestionV4Response>,
	) {}

	async get(
		params: GetBeneficiaryAddressSuggestionV4Params,
	): Promise<GetBeneficiaryAddressSuggestionV4Response> {
		const {acceptedFlag, signal} = params;

		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params: {acceptedFlag},
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return null;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
